import type { ReactNode } from 'react';

export const symbol_contextual_token: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M274-325h206q12.75 0 21.38-8.63Q510-342.25 510-355v-42q0-12.75-8.62-21.38Q492.75-427 480-427H274q-12.75 0-21.37 8.62Q244-409.75 244-397v42q0 12.75 8.63 21.37Q261.25-325 274-325Zm370 0h42q12.75 0 21.38-8.63Q716-342.25 716-355v-249q0-12.75-8.62-21.38Q698.75-634 686-634h-42q-12.75 0-21.37 8.62Q614-616.75 614-604v249q0 12.75 8.63 21.37Q631.25-325 644-325ZM274-532h206q12.75 0 21.38-8.63Q510-549.25 510-562v-42q0-12.75-8.62-21.38Q492.75-634 480-634H274q-12.75 0-21.37 8.62Q244-616.75 244-604v42q0 12.75 8.63 21.37Q261.25-532 274-532ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
